import { Link } from "react-router-dom";

function linkClass(active, key) {
  return `profile-manage-settings-link${active === key ? " profile-manage-settings-link--active" : ""}`;
}

/**
 * Profile / Recruitment / Response / Purchases settings switcher on recruitment profile routes.
 *
 * @param {"profile" | "recruitment" | "response" | "purchases"} active
 * @param {(tab: "profile" | "recruitment") => void} [onSelectTab] — when set, profile & recruitment are in-page buttons (recruitment profile page).
 */
export default function RecruitmentProfileSettingsNav({ active, onSelectTab }) {
  const useInPageTabs = typeof onSelectTab === "function";

  function renderItem(key, label) {
    const className = linkClass(active, key);
    const isCurrent = active === key;

    if (isCurrent) {
      return (
        <span key={key} className={className} aria-current="page">
          {label}
        </span>
      );
    }

    if (useInPageTabs && (key === "profile" || key === "recruitment")) {
      return (
        <button key={key} type="button" className={className} onClick={() => onSelectTab(key)}>
          {label}
        </button>
      );
    }

    const to =
      key === "profile"
        ? "/recruitment-profile"
        : key === "recruitment"
          ? "/recruitment-profile?tab=recruitment"
          : key === "purchases"
            ? "/purchases"
            : "/response-settings";

    return (
      <Link key={key} to={to} className={className}>
        {label}
      </Link>
    );
  }

  return (
    <div className="profile-manage-settings-links nd1-recruitment-profile-tabs" aria-label="Recruitment profile navigation">
      {renderItem("profile", "Profile Settings")}
      {renderItem("recruitment", "Recruitment Settings")}
      {renderItem("response", "Response Settings")}
      {renderItem("purchases", "Purchases")}
    </div>
  );
}
